import {doc} from './docs.js';
import Colors from 'components/Colors.js';
import CustomZObject from "../custom/CustomZObject.js";

const colors = new Colors();

doc(
    "comment",
    {
    },
    "Creates comment box"
);

export const comment = (object) => {
    let commentBox = new CommentBox(object);
    let backgroundColor = object.sequencerEngine.state.sequencer.backgroundColor;

    object.attributes["primary-color"] = "#ffff13";
    object.attributes["secondary-color"] = "#000000";
    
    object.width = 100;
    object.height = 25;
    object.effect = commentBox;
    return () => {
    };
};

class CommentBox extends CustomZObject {
    constructor(zobject) {
        super(zobject);
        this.text = "";
    }

    fromJson(json) {
        this.text = json.text;
    }

    getJson() {
        return {
            text: this.text,
        };
    }

    getParameters() {
        return [];
    }
}

